import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { startMatch2 } from '../match2.sequence';
import { Feature } from 'src/replicant/analytics';
import TutorialHand from 'src/game/components/shared/TutorialHand';
import StateObserver from 'src/StateObserver';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupStarsPinch extends PopupBasic {
  private playButton: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      ...opts,
      zIndex: 10000,
      width: 556,
      height: 455,
      tracking: {
        feature: Feature.DECORATION_PROGRESSION._,
        $subFeature: Feature.DECORATION_PROGRESSION.STARS_PINCH._,
      },
      skipTitle: true,
    });

    this.box.updateOpts({
      image: `assets/ui/popups/dialog_panel.png`,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 72, right: 72 },
        vertical: { top: 72, bottom: 72 },
      },
    });
    this.buttonClose.removeFromSuperview();

    new LangBitmapFontTextView({
      superview: this.box,
      color: '#947372',
      size: 40,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      font: 'Body',
      width: 556,
      height: 88,
      y: 68,
      x: this.box.style.width / 2,
      localeText: () => i18n('match2.starsPinch.title'),
    });

    //  Separator
    new View({
      superview: this.box,
      x: this.box.style.width / 2,
      height: 5,
      width: 443,
      y: 112,
      backgroundColor: '#deedfa',
      centerOnOrigin: true,
    });

    // Close button
    new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.cancel,
      font: 'Body',
      fontSize: 40,
      localeText: () => i18n('basic.close'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        return opts.close();
      },
      width: 225,
      height: 86,
      x: 150,
      y: this.box.style.height - 100,
      labelOffsetX: -10,
      centerOnOrigin: true,
      tracking: {
        feature: Feature.DECORATION_PROGRESSION._,
        $subFeature: Feature.DECORATION_PROGRESSION.STARS_PINCH.CLOSE,
      },
    });

    // Play button
    this.playButton = new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.secondary,
      font: 'Body',
      fontSize: 40,
      localeText: () => i18n('match2.starsPinch.button'),
      onClick: async () => {
        sounds.sfx.play('ok');
        opts.close();
        await startMatch2();
      },
      width: 225,
      height: 86,
      x: 405,
      y: this.box.style.height - 100,
      labelOffsetX: -10,
      centerOnOrigin: true,
      tracking: {
        feature: Feature.DECORATION_PROGRESSION._,
        $subFeature: Feature.DECORATION_PROGRESSION.STARS_PINCH.PLAY,
      },
    });

    this.message.updateOpts({
      x: 40,
      y: 107,
      width: 470,
      height: 200,
      zIndex: 1,
      size: 29,
      color: '#c49291',
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(['assets/ui/popups/dialog_panel.png']);
  }

  public init({ tutorial }: { tutorial?: boolean }) {
    super.init({
      message: i18n('match2.starsPinch.message'),
    });

    // Show tutorial hand.
    if (!tutorial) return;
    this.tutorialShow();
  }

  private tutorialShow() {
    const hand = new TutorialHand({});
    this.playButton.addSubview(hand);
    hand.fadeIn(70, 50, false);
  }
}
